import React from 'react';
import '../components/styles/Bar.css';


export default function Bar() {
  return (
    <div>
      <div className="containerp">
        <h4>Categories</h4>
        <h5>FAQ</h5>
        <a href='https://bedrocklauncher.github.io/faq'><h6>FAQ</h6></a>
        <a href='https://bedrocklauncher.github.io/faq'><h6>Data FAQ</h6></a>
        <a href='https://bedrocklauncher.github.io/faq'><h6>Accounts FAQ</h6></a>
        <a href='https://bedrocklauncher.github.io/faq'><h6>Versions FAQ</h6></a>
        <a href='https://bedrocklauncher.github.io/faq'><h6>Miscellaneous FAQ</h6></a>
        <h4>Releases</h4>
        <a href="https://bedrocklauncher.github.io/faq"><h6>Releases</h6></a>
        <a href="https://bedrocklauncher.github.io/faq"><h6>Public Releases</h6></a>
        <a href="https://bedrocklauncher.github.io/faq"><h6>Beta Releases</h6></a>
        <h4>DOCS</h4>
        <h5>DEV INFO</h5>
        <a href="https://github.com/BedrockLauncher/BedrockLauncher/"><h6>Launcher Source</h6></a>
        <a href="https://github.com/BedrockLauncher/BedrockLauncher.github.io"><h6>Website Source</h6></a>
        <a href="https://bedrocklauncher.github.io/docs/dev/compiling"><h6>Compiling</h6></a>
        <a href="https://bedrocklauncher.github.io/docs/dev/contributing"><h6>Contributing</h6></a>
        <a href="https://bedrocklauncher.github.io/docs/dev/dev-software-prerequisites"><h6>Dev software prerequisites</h6></a>
        <a href="https://bedrocklauncher.github.io/docs/dev/software-prerequisites"><h6>Software prerequisites</h6></a>
        <a href="https://bedrocklauncher.github.io/docs/dev/hardware-prerequisites"><h6>Hardware prerequisites</h6></a>
        <h5>Legal</h5>
        <a href="https://bedrocklauncher.github.io/docs/legal/code-of-conduct"><h6>Code of conduct</h6></a>
        <a href="https://bedrocklauncher.github.io/docs/legal/disclaimers"><h6>Disclaimers</h6></a>
        <a href="https://bedrocklauncher.github.io/docs/legal/license">License</a>
        <h4>OTHERS</h4>
        <a href="https://bedrocklauncher.github.io/downloads">Download Launcher</a>
        <a href='https://bedrocklauncher.github.io/search'>Search</a>
      </div>
    </div>
  )
}
